module.exports = __webpack_public_path__ + "media/images/lb/295-c264aa34f5662373348e228aed9cd296.svg";